import React, { Children, useState } from 'react';
import { Svg } from '@vfit/shared/atoms';
import { T_ConsumerOfferPromotionProps } from './consumerOfferPromotion.models';
import ConsumerInflation from '../ConsumerInflation/consumerInflation';
import { ProductCardSpecItemAction } from '../Inflation/inflation.style';
import { purify } from '@vfit/shared/themes';
import ConsumerVodafoneModal from '../ConsumerVodafoneModal/consumerVodafoneModal';
import {
  LabelCta,
  PromotionContainer,
  PromotionDisclaimer,
  PromotionTitle,
  PromotionTitleContainer,
} from './consumerOfferPromotion.style';

const ConsumerOfferPromotion = ({
  promoList,
  mapConfig,
  isAlternativeOffer = false,
  inflation,
  isGlobalPromoActive,
  isConsumer = false,
}: T_ConsumerOfferPromotionProps) => {
  const [openModal, setOpenModal] = useState(false);

  const [modal, setModal] = useState({
    show: false,
    text: '',
    title: '',
  });

  const [purifiedPromoTitle, purifiedModalTitle, purifiedModalText] = purify([
    promoList.title || '',
    modal?.title || '',
    modal?.text || '',
  ]);

  const onCloseModal = () => {
    setModal({
      show: false,
      text: '',
      title: '',
    });
  };

  return (
    <>
      {promoList?.elements && promoList?.elements?.length > 0 && (
        <PromotionContainer>
          {purifiedPromoTitle && (
            <PromotionDisclaimer
              dangerouslySetInnerHTML={{
                __html: purifiedPromoTitle,
              }}
            />
          )}
          <PromotionTitleContainer>
            {Children.toArray(
              promoList?.elements?.map(({ title, description, shortDescription }) => (
                <>
                  {shortDescription && (
                    <PromotionTitle
                      dangerouslySetInnerHTML={{
                        __html: shortDescription,
                      }}
                    />
                  )}

                  {(title || description) && (
                    <div
                      className="tooltip"
                      role="presentation"
                      onClick={() => {
                        setModal({
                          title,
                          text: description,
                          show: true,
                        });
                      }}
                    >
                      <ProductCardSpecItemAction>
                        {isConsumer ? <Svg name="info" height={16} width={16} /> : '+'}
                      </ProductCardSpecItemAction>
                    </div>
                  )}
                </>
              )),
            )}
          </PromotionTitleContainer>
        </PromotionContainer>
      )}

      <ConsumerVodafoneModal
        isModalShown={modal.show}
        onCloseModal={onCloseModal}
        purifiedModalTitle={purifiedModalTitle}
        purifiedModalText={purifiedModalText}
      />

      {inflation &&
        inflation[0]?.text &&
        isGlobalPromoActive &&
        inflation?.map(({ text, popup, color, disclaimer }) => (
          <ConsumerInflation
            key={text}
            inflationTitle={text}
            popup={popup}
            color={color}
            inflationDisclaimer={disclaimer ?? ''}
            isGlobalPromo={isGlobalPromoActive}
            isConsumer={isConsumer}
          />
        ))}

      {isAlternativeOffer && (
        <>
          <LabelCta onClick={() => setOpenModal(true)}> {mapConfig?.labelCta} </LabelCta>

          <ConsumerVodafoneModal
            isModalShown={openModal}
            onCloseModal={() => setOpenModal(false)}
            purifiedModalTitle={mapConfig?.modalTitle}
            purifiedModalText={mapConfig?.modalContent}
          />
        </>
      )}
    </>
  );
};

export default ConsumerOfferPromotion;

